import {init, BrowserOptions, captureException} from '@sentry/react';
import {headers, isDev} from 'utils/constants';
import {
    getCurrentSearch,
    getCurrentSearchParams,
    getLeadFormRequestUrl,
    initDebugInfo,
    initSideEffects,
} from 'utils/utils';

(function setupSentry() {
    if (!process.env.SENTRY_DSN_OR) {
        return;
    }
    const options: BrowserOptions = {
        dsn: process.env.SENTRY_DSN_OR,
        environment: process.env.NODE_ENV,
        tracesSampleRate: 1.0,
        // выключает поход sentry на метод /envelope который у нас закрыт
        autoSessionTracking: false,
        denyUrls: ['chrome-extension'],
        beforeSend: (event, hint) => {
            if (isDev) {
                console.warn('SENTRY ERROR: ', hint.originalException || hint.syntheticException || event);
                return null; // this drops the event and nothing will be send to sentry
            }
            return event;
        },
        ignoreErrors: [
            /*
               Проблема во внешнем расширении  https://stackoverflow.com/questions/76697631/cannot-read-properties-of-undefined-reading-firefoxsample
               видимо, после обновления что-то пошло не так у них
             */
            /firefoxSample/gi,

            /^TypeError: mjs./gi, // спамит по 2,5к событий в день, что-то стороннее
        ],
    };

    if (window.SENTRY_RELEASE) {
        options['release'] = window.SENTRY_RELEASE?.id;
    }
    init(options);
})();

initDebugInfo();

const searchParams = getCurrentSearchParams(getCurrentSearch());
initSideEffects(searchParams);

export const initRequestDataHash = searchParams.formDataHash;
export const initRequest = !initRequestDataHash
    ? null
    : fetch(getLeadFormRequestUrl({...searchParams, formDataHash: initRequestDataHash}), {
          headers,
      }).then((res) => {
          (async () => {
              try {
                  const parsedRes = await res.clone().json();
                  if (res.ok) {
                      // предзагружаем обложку если есть и первая страница не лендинг
                      if (!parsedRes.landing && parsedRes.main_image) {
                          // для leadads
                          const link = document.createElement('link');
                          link.setAttribute('rel', 'preload');
                          link.setAttribute('as', 'image');
                          link.setAttribute('href', parsedRes.main_image.variants['320x180']);
                          document.head.appendChild(link);
                      } else if (parsedRes?.form?.data?.data?.style?.header_background_new?.norm) {
                          // для yclients
                          const link = document.createElement('link');
                          link.setAttribute('rel', 'preload');
                          link.setAttribute('as', 'image');
                          link.setAttribute('href', parsedRes.form.data.data.style.header_background_new.norm);
                          document.head.appendChild(link);
                      }
                  }
              } catch (e) {
                  captureException(e);
              }
          })();
          return res;
      });
